import { ScrollableList } from '@ps/isp-web-component-library';
import type { RaceView } from '@ps/isp-web-services-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { select } from '@swf/core/store';
import { SportsLink } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import RaceDetails from '@swf/sports/components/RaceDetails/RaceDetails';
import { ariaLabelScrollLeft, ariaLabelScrollRight } from '@swf/sports/utils/getAriaLabels';
import { getRaceTimeFromRaceId } from '@swf/sports/utils/getRaceTimeFromRaceId';

import styles from './RaceInfo.scss';

interface Props {
  selectedRace: RaceView;
  allRaces: RaceView[];
}

const RaceInfo: React.FC<Props> = ({ selectedRace, allRaces }) => {
  const { meetingId, raceId, eventTypeSlug, venueSlug, eventTypeId } = useSelector(
    select.sports.getUrlParams
  );

  const activeRaceId = `${meetingId}.${raceId}`;
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div data-testid="sports-race-info">
      <div className={styles.raceDetailsContainer}>
        <RaceDetails
          details={selectedRace.details}
          venue={selectedRace.venue}
          startTime={selectedRace.startTime}
        />
      </div>
      <ScrollableList
        variant="square-scroll-arrows"
        space="xs"
        slotProps={{
          previousButton: {
            'aria-label': formatMessage(ariaLabelScrollLeft)
          },
          nextButton: {
            'aria-label': formatMessage(ariaLabelScrollRight)
          }
        }}
      >
        {allRaces.map((race) => (
          <ScrollableList.Pill
            key={`race_${race.raceId}`}
            as={SportsLink}
            active={race.raceId === activeRaceId}
            alias="sportsAnimalRacingRace"
            role="link"
            values={{
              eventTypeSlug,
              eventTypeId,
              venueSlug,
              meetingId,
              raceId: getRaceTimeFromRaceId(race.raceId)
            }}
          >
            <FormattedDateTime date={race.startTime} />
          </ScrollableList.Pill>
        ))}
      </ScrollableList>
    </div>
  );
};

export default RaceInfo;
